import React, { Component, useEffect, useState } from "react";
import Chart from "react-apexcharts";
import { formatNumber } from "../../utils/helpers";

const GraficoBarrasVendedor = (props) => {
	const containerStyle = {
		display: "flex",
		flexDirection: "column",
		justifyItem: "center",
	};
	const [state, setState] = useState({
		options: {
			chart: {
				id: "basic-bar",
				type: "bar",
				stacked: true,
				width: "100%",
			},
			plotOptions: {
				bar: {
					horizontal: true,
					barWidth: "85%",
					barHeight: "15",
					dataLabels: {
						position: "center",
						maxItems: 100,
						hideOverflowingLabels: true,
						orientation: "horizontal",
						total: {
							enabled: false,
							formatter: undefined,
							offsetX: 0,
							offsetY: 0,
							style: {
								color: "#373d3f",
								fontSize: "13px",
								fontFamily: undefined,
								fontWeight: 600,
							},
						},
					},
				},
			},
			grid: {
				borderColor: "red",
				show: false,
			},
			legend: {
				showForSingleSeries: false,
				position: "top",
				horizontalAlign: "center",
				fontSize: "15px",
				fontFamily: "Helvetica, Arial, sans-serif",
			},
			tooltip: {
				enabled: true,
			},
			yaxis: {
				show: false,
			},
			tooltip: {
				y: {
					formatter: function (value) {
						return "$" + formatNumber(value.toFixed(2));
					},
				},
			},
			xaxis: {
				labels: {
					formatter: function (value) {
						return "$" + formatNumber(value.toFixed(2));
					},
					padding: {
						top: 0,
						bottom: -2,
					},
				},
			},
			dataLabels: {
				formatter: function (val, opts) {
					return "$" + formatNumber(val.toFixed(2));
				},
			},
			responsive: [
				{
					breakpoint: 575,
					options: {
						chart: {
							width: "100%",
						},
						legend: {
							fontSize: "12px",
						},
						xaxis: {
							labels: {
								formatter: function (value) {
									return "$" + formatNumber(value.toFixed(2));
								},
								padding: 0,
								
								style: {
									fontSize: "7px", // Adjust font size for responsive mode
								},
							},
						},
						yaxis: {
							labels: {
								style: {
									fontSize: "12px", // Adjust font size for responsive mode
								},
							},
						},
					},
				},
			],
		},

		series: [],
	});

	useEffect(() => {
		const series = [];
		const categories = [];

		const dataWithPositiveValues = Object.values(props.data).filter(
			(val) => val.value > 0
		);

		// este es un index para saber cuales elementos del prop data son mayores a 0
		let indexOfDataBiggerThan0 = dataWithPositiveValues.length;

		dataWithPositiveValues.forEach((data) => {
			const newArray = Array(indexOfDataBiggerThan0).fill(0);
			newArray[series.length] = data.value;
			series.push({ name: data.label, data: newArray });
			categories.push(data.label);
		});
		
		const newChartHeight = 100;

		setState((prevState) => ({
			...prevState,
			series,
			options: {
				...prevState.options,
				xaxis: {
					...prevState.options.xaxis,
					categories,
				},
			},
			chartHeight: newChartHeight,
		}));
	}, [props.data]);

	return (
		<div
			className="mb-0 bg-white"
			style={containerStyle}
		>
			<style>
				{`
    
         	.title{
				position:relative;
				display:flex;
				justify-content:center;
				color: rgb(55, 61, 63);
    			font-size: 15px;
    			font-weight: 600;
    			font-family: Helvetica, Arial, sans-serif;
				padding:0px;
				
			}
           
          `}
			</style>
			<div className="title">Despachos internos</div>
				<Chart
					options={{
						...state.options,
						chart: {
							...state.options.chart,
							height: state.chartHeight,
						},
					}}
					series={state.series}
					type="bar"
					height={state.chartHeight}
					width="100%"
				/>
			</div>
	);
};

export default GraficoBarrasVendedor;
